import { uuid } from 'uuidv4';

import $ from 'jquery';
import 'jquery-ui-dist/jquery-ui';
import 'jquery-mask-plugin';

import {
  addDays,
  subDays,
  parse,
  isValid,
  isBefore,
  isAfter,
  isEqual,
  setHours,
  setMinutes,
  setSeconds,
  setMilliseconds,
  format,
  differenceInMilliseconds,
} from 'date-fns';

import VASTPlayer from 'vast-player';

import ApiService from '../services/ApiService';
import EventService from '../services/EventService';

import CampaignRender from '../renders/campaign';
import Util from '../utils';

const VALIDATE_DATE = {
  no_limit: 'no-limit',
  now: 'now',
  yesterday: 'yesterday',
  tomorrow: 'tomorrow',
  fixed: 'fixed',
};

const CAMPAIGN_TYPE_CODE = 'CODE';
const CAMPAIGN_TYPE_PROVIDER = 'PROVIDER';

class CampaignController {
  type = CAMPAIGN_TYPE_PROVIDER;

  context;

  apiService;
  eventService;
  code;
  contentBase;
  contentHeader;
  content;

  campaign;
  currentQuestion;
  currentQuestionIndex;
  cbGiveBenefit;
  isNextQuestion = true;
  confirmationTermAccept = false;
  modeEmbedded = false;

  mainData;

  render;

  zone;
  nextCampaign = { enabled: false, label: '', campaignIndex: 0 };

  constructor() {
    this.render = new CampaignRender();
    this.apiService = new ApiService();
    this.eventService = new EventService();
    $.datepicker.setDefaults({
      dateFormat: 'dd/mm/yy',
      dayNames: [
        'Domingo',
        'Segunda',
        'Terça',
        'Quarta',
        'Quinta',
        'Sexta',
        'Sábado',
      ],
      dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S', 'D'],
      dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'],
      monthNames: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
      monthNamesShort: [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez',
      ],
      nextText: 'Proximo',
      prevText: 'Anterior',
    });
  }

  validateZone = (zone) => {
    this.zone = zone;
    if (
      zone &&
      zone.extra &&
      zone.extra.config &&
      zone.extra.config.nextCampaign
    ) {
      const { nextCampaign } = zone.extra.config;
      this.nextCampaign = { ...nextCampaign, campaignIndex: 0 };
    }
  };

  loadCampaign = async (zoneUuid, userId, context, cb, urlAdserver) => {
    this.loadCampaign(zoneUuid, userId, context, cb, urlAdserver, null);
  };

  loadCampaign = async (zoneUuid, userId, context, cb, urlAdserver, source) => {
    try {
      const result = await this.apiService.init(
        zoneUuid,
        userId,
        context,
        urlAdserver
      );
      if (result.status === 200 && result.data) {
        const { requestId, userId, campaigns, zone } = result.data;

        this.validateZone(zone);

        this.context = {
          requestId,
          userId,
          campaigns,
          zone,
          source,
        };
        cb({ status: true, campaigns });
      } else {
        this.context = null;
        cb({ status: false });
      }
    } catch (e) {
      cb({ status: false, error: e });
    }
  };

  loadCampaignCode = async (code, cb, urlAdserver) => {
    this.loadCampaignCode(code, cb, urlAdserver, null);
  };

  loadCampaignCode = async (code, cb, urlAdserver, source) => {
    try {
      this.code = code;
      const result = await this.apiService.initByCode(code, urlAdserver);
      if (result.data) {
        this.type = CAMPAIGN_TYPE_CODE;

        // this.eventService.initContext({
        //   requestUuid: result.data.requestId,
        //   terminal: result.data.userId,
        //   zoneUuid: null,
        //   source,
        // });
        // this.campaign = result.data;

        const { requestId, userId, campaigns, zone } = result.data;

        this.validateZone(zone);

        this.context = {
          requestId,
          userId,
          campaigns,
          zone,
          source,
        };

        cb({ status: true, campaigns });
      } else {
        this.context = null;
        cb({ status: false });
      }
    } catch (e) {
      cb({ status: false, error: e });
    }
  };

  sendEvent = async (event) => {
    const {
      context: { userId },
      campaign: { campaignUuid },
    } = this;
    try {
      this.eventService.sendEvent(campaignUuid, event);
    } catch (e) {
      this.apiService.errorEvent(
        campaignUuid,
        userId,
        'error-send-event-hermes',
        e.message || e
      );
    }
  };

  nextRenderCampaign = async () => {
    this.nextCampaign.campaignIndex += 1;
    
    try {
      const idContentUuid = uuid();

      $(this.contentBase).empty().append(`
        <div ${this.modeEmbedded ? 'class="content-border-campaign"' : ''} >
          <div id="header-${idContentUuid}" class="header-artemis-campaign"></div>
          <div id="content-${idContentUuid}"></div>
        </div>
      `);

      this.contentHeader = document.getElementById(`header-${idContentUuid}`);
      this.content = document.getElementById(`content-${idContentUuid}`);

      await this.initRender();
    } catch (e) {
      console.error(e);
    }
  };

  renderCampaign = async ({
    content,
    cb,
    cbGiveBenefit = null,
    modeEmbedded = false,
    overrideColors = null,
  }) => {
    try {
      this.contentBase = content;
      this.overrideColors = overrideColors;
      this.modeEmbedded = modeEmbedded;

      const idContentUuid = uuid();

      $(this.contentBase).empty().append(`
        <div ${this.modeEmbedded ? 'class="content-border-campaign"' : ''} >
          <div id="header-${idContentUuid}" class="header-artemis-campaign"></div>
          <div id="content-${idContentUuid}"></div>
        </div>
      `);

      this.contentHeader = document.getElementById(`header-${idContentUuid}`);
      this.content = document.getElementById(`content-${idContentUuid}`);

      this.cbGiveBenefit = cbGiveBenefit;
      await this.initRender();
      if (cb) {
        cb({ status: true });
      }
    } catch (e) {
      console.error(e);
      if (cb) {
        cb({ status: true, error: e });
      }
    }
  };

  initRender = () => {
    const {
      context: { campaigns },
      nextCampaign: { campaignIndex },
    } = this;

    this.campaign = campaigns[campaignIndex];

    this.initRenderCampaign();
  };

  validateBenefitPreCampaign = () => {
    const {
      context: { userId },
      campaign: {
        campaignUuid,
        mainData: { type, media },
      },
      apiService,
    } = this;

    if (type !== 'interno' && type !== 'internal') {
      return Promise.resolve(0);
    }

    const existBenefitPreCampaign = media.find(
      (m) => (Util.isVast(m) && !m.proxy) || Util.isVpaid(m)
    );

    return new Promise((resolve, reject) => {
      if (!existBenefitPreCampaign) {
        resolve(0);
        return;
      }
      async function validate(sequenceValidate) {
        try {
          await Util.validateConnection();
          resolve(sequenceValidate);
        } catch (e) {
          if (sequenceValidate < 5) {
            setTimeout(() => validate(sequenceValidate + 1), 1000);
          } else {
            try {
              await apiService.errorEvent(
                campaignUuid,
                userId,
                'error-validate-benefit-pre-campaign',
                {
                  tentatives: sequenceValidate,
                }
              );
            } catch (e) {}
            reject(sequenceValidate);
          }
        }
      }
      validate(1);
    });
  };

  initRenderCampaign = async () => {
    const {
      context: {
        userId,
        source,
        zone: { uuid: zoneUuid },
      },
      campaign: { campaignUuid, trackingId },
    } = this;

    if (trackingId) {
      this.apiService.setRequestId(trackingId);
      this.eventService.initContext({
        requestUuid: trackingId,
        terminal: userId,
        zoneUuid,
        source: source || 'Artemis - Bemobi',
      });
    }

    try {
      const initValidate = new Date();

      $(this.content).empty().append(`
        <div class="content-loading">
          <div class="loader-validate-campaign"></div>
        </div>
      `);

      await this.validateBenefitPreCampaign();
      const delayEventMillis = differenceInMilliseconds(
        new Date(),
        initValidate
      );
      this.apiService.impressionEvent(campaignUuid, userId, {
        delayEventMillis,
      });
      this.sendEvent('impression');

      if (this.type === CAMPAIGN_TYPE_CODE) {
        const { mainData } = this.campaign;
        this.mainData = mainData;
        this.renderInitTypeInternal();
      } else {
        this.validateTypeCampaing();
      }
    } catch (e) {
      console.log(e);
      const { enabled, campaignIndex } = this.nextCampaign;
      if (enabled) {
        const { campaigns } = this.context;
        if (campaigns.length - 1 > campaignIndex) {
          this.nextRenderCampaign();
          return;
        }
      }

      $(this.content).empty().append(`
        <div class="content-campaign-error">
          <p>Ops... acabaram os conteúdos.
        </div>
      `);
    }
  };

  loadProvider = () => {
    const { campaignUuid } = this.campaign;
    const {
      provider: { htmlContent, script },
    } = this.mainData;

    $(this.contentBase)
      .find('.content-border-campaign')
      .removeClass('content-border-campaign');

    if (htmlContent) {
      $(this.content)
        .empty()
        .append(Util.injectCampaignUuid(htmlContent, campaignUuid));
    }
    if (script) {
      const scriptConvert = Util.injectCampaignUuid(script, campaignUuid);
      $(this.content).append(`
        <script type="text/javascript">
          ${scriptConvert}
        </script>
      `);
    }
  };

  loadEmbeddedPage = (media) => {
    const {
      context: { userId },
      campaign: { campaignUuid },
    } = this;

    const { content } = media;

    if (content) {
      $(this.content).empty().append(`
        <div class="content-step-1">
          <div class="content-embedded-page">
            <iframe src="https://${content}" width="100%" height="400" frameborder="0"></iframe>
            <button class="btn-avancar background-primary color-secondary" id="avancar_btn_step_1">
              AVANÇAR
            </button>
          </div>
        </div>
      `);
    }

    try {
      this.apiService.interactionEvent(
        campaignUuid,
        userId,
        media.uuid || null
      );
    } catch (e) {
      console.log('Erro ao reportar o evento INTERACTION');
    }
    this.sendEvent('interaction');

    $('#avancar_btn_step_1').click(() => {
      this.sendEventComplete();
      this.nextRenderCurrentMedia();
    });
  };

  loadVastAndVpaid = (media) => {
    const {
      context: { userId },
      campaign: { campaignUuid },
    } = this;

    const { content, thumbnail, proxy, type } = media;

    const proxyMedia = type === 'vpaid' ? false : proxy;

    let uri = null;
    if (Util.validateUrl(content)) {
      uri = content;
    } else {
      var blob = new Blob([content], { type: 'text/xml' });
      uri = URL.createObjectURL(blob);
    }

    $(this.content).empty().append(`
      <div class="content-step-1-vast">
        <div class="step_1_video_text">
          Assista ao vídeo até o fim e ganhe um pacote de 20 MB
        </div>
        <div id="container-vast">
          <div id="content-video-vast" class="content-video-vast"></div>
          <div id="content-thumbnail" class="content-video-vast-thumbnail">
            ${thumbnail ? `<img src="${thumbnail}" alt="Play video">` : ''}
            <button type="button" id="playVideo">
              <svg width="34" height="34" xmlns="http://www.w3.org/2000/svg"><g><title>background</title><rect fill="none" id="canvas_background" height="402" width="582" y="-1" x="-1"/></g><g><title>Layer 1</title><path id="svg_2" fill="#292929" d="m17.078,0.25c-9.389,0 -17,7.611 -17,17s7.611,17 17,17c9.389,0 17,-7.611 17,-17s-7.611,-17 -17,-17zm0,31c-7.732,0 -14,-6.268 -14,-14c0,-7.732 6.268,-14 14,-14s14,6.268 14,14c0,7.732 -6.268,14 -14,14z"/><polygon id="svg_3" points="14,23.963 23,17.25 14,10.537  " fill="#292929"/></g></svg>
            </button>
          </div>
        </div>
      </div>
    `);
    $('#content-thumbnail').click(() => {
      $('#content-thumbnail').hide();
      setTimeout(() => player.startAd(), 300);
    });
    $('#content-video-vast').click(() => {
      $('#content-thumbnail').hide();
      setTimeout(() => player.startAd(), 300);
    });

    const contentVideoVast = $('#content-video-vast');

    var player = new VASTPlayer(contentVideoVast[0]);

    if (!proxyMedia) {
      player.once('AdVideoStart', () => {
        console.log('AdVideoStart');
        this.apiService.vastEvent(
          campaignUuid,
          userId,
          media.uuid || null,
          'start'
        );
        this.apiService.vastEvent(
          campaignUuid,
          userId,
          media.uuid || null,
          'creativeView'
        );
      });
      player.once('AdVideoFirstQuartile', () => {
        console.log('AdVideoFirstQuartile');
        this.apiService.vastEvent(
          campaignUuid,
          userId,
          media.uuid || null,
          'firstQuartile'
        );
      });
      player.once('AdVideoMidpoint', () => {
        console.log('AdVideoMidpoint');
        this.apiService.vastEvent(
          campaignUuid,
          userId,
          media.uuid || null,
          'midpoint'
        );
      });
      player.once('AdVideoThirdQuartile', () => {
        console.log('AdVideoThirdQuartile');
        this.apiService.vastEvent(
          campaignUuid,
          userId,
          media.uuid || null,
          'thirdQuartile'
        );
      });
      player.once('AdVideoComplete', () => {
        console.log('AdVideoComplete');
        this.apiService.vastEvent(
          campaignUuid,
          userId,
          media.uuid || null,
          'complete'
        );
      });
    }
    player.once('AdStopped', () => {
      console.log('AdStopped');
      try {
        this.apiService.interactionEvent(
          campaignUuid,
          userId,
          media.uuid || null
        );
        this.sendEvent('interaction');
      } catch (e) {
        this.apiService.errorEvent(
          campaignUuid,
          userId,
          'error-send-iteraction-event',
          e.message || e
        );
      }
      // this.sendEventComplete();
      this.nextRenderCurrentMedia();
    });
    // player.once('AdLoaded', () => {});
    player.once('AdError', (e) => {
      this.apiService.errorEvent(
        campaignUuid,
        userId,
        'error-vast-ad-error',
        e.message || e
      );
    });
    player
      .load(uri)
      .then(() => {
        player.pauseAd();
      })
      .catch(function (reason) {
        this.apiService.errorEvent(
          campaignUuid,
          userId,
          'error-vast-load',
          reason.message
        );
        setTimeout(function () {
          throw reason;
        }, 0);
      });
  };

  validateTypeCampaing = () => {
    const { mainData } = this.campaign;
    this.mainData = mainData;
    if (this.mainData.type === 'interno' || this.mainData.type === 'internal') {
      this.renderInitTypeInternal();
    } else if (this.mainData.type === 'provedor' || this.mainData.type === 'provider') {
      this.loadProvider();
    }
  };

  initLayout = (layout) => {
    const { overrideColors } = this;
    if (layout || overrideColors) {
      if (layout.title) {
        document.title = layout.title;
      }

      const primaryColor =
        overrideColors && overrideColors.primaryColor
          ? overrideColors.primaryColor
          : layout.primaryColor;
      const secondaryColor =
        overrideColors && overrideColors.secondaryColor
          ? overrideColors.secondaryColor
          : layout.secondaryColor;

      $('head').append(`
        <style type="text/css">
          .color-primary { color: ${primaryColor} !important; }
          .border-primary { border-color: ${primaryColor} !important; }
          .background-primary { background-color: ${primaryColor} !important; }
          .color-secondary { color: ${secondaryColor} !important; }
          .border-secondary { border-color: ${secondaryColor} !important; }
          .background-secondary { background-color: ${secondaryColor} !important; }

          .step2_answer[type='radio'],
          .step2_answer[type='checkbox'] { 
            border-color: ${primaryColor} !important; 
            color: ${primaryColor} !important; 
            background-color: ${secondaryColor} !important; 
          }
          .step2_answer[type='radio']:checked,
          .step2_answer[type='checkbox']:checked { 
            background-color: ${primaryColor} !important; 
          }

          #step2_question_steps .step-question-dot {
            border-color: ${primaryColor} !important;
          }
          #step2_question_steps .step-question-dot.active {
            background-color: ${primaryColor} !important;
          }
        </style>
      `);

      // <div id="header" class="header"></div>
      $(this.contentHeader).empty().append(`
        ${layout.icon ? `<img src="${layout.icon}" />` : ''}
        <div>
          ${
            layout.primaryInformation
              ? `<p>${layout.primaryInformation}</p>`
              : ''
          }
          ${
            layout.secondaryInformation
              ? `<span>${layout.secondaryInformation}</span>`
              : ''
          }
        </div>
      `);
    }
  };

  renderInitTypeInternal = () => {
    const {
      mainData: { layout, media },
    } = this;

    this.initLayout(layout);

    this.currentMediaIndex = 0;
    this.currentMedia = media[0];
    this.renderCurrentMedia();
  };

  nextRenderCurrentMedia = () => {
    const {
      mainData: { media },
    } = this;

    if (this.currentMediaIndex >= media.length - 1) {
      this.giveBebefit();
    } else {
      this.currentMediaIndex = this.currentMediaIndex + 1;
      this.currentMedia = media[this.currentMediaIndex];
      this.renderCurrentMedia();
    }
  };

  renderCurrentMedia = () => {
    const {
      context: { userId },
      campaign: { campaignUuid },
      currentMedia,
    } = this;

    if (Util.isVast(currentMedia)) {
      this.loadVastAndVpaid(currentMedia);
    } else if (Util.isVpaid(currentMedia)) {
      this.loadVastAndVpaid(currentMedia);
    } else if (Util.isEmbeddedPage(currentMedia)) {
      this.loadEmbeddedPage(currentMedia);
    } else if (currentMedia.type === 'data_search') {
      this.renderForm();
    } else if (Util.isVideo(currentMedia)) {
      const { thumbnail } = currentMedia;
      $(this.content).empty().append(`
        <div class="content-step-1">
          <div class="step_1_video_text">
            Participe da campanha
          </div>
          <video id="video_step_1" 
            ${thumbnail ? `poster="${thumbnail}"` : ''}
            preload="auto" controls controlsList="nodownload">
            <source src="${
              currentMedia.content || currentMedia.url
            }" type="video/mp4" />
            <p class="vjs-no-js">To view this video please enable JavaScript, and consider upgrading to a web browser that <a href="http://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a></p>
          </video>
        </div>
      `);
      const video = $('#video_step_1');
      video.on('ended', () => {
        this.sendEventComplete();
        this.nextRenderCurrentMedia();
      });
      video.on('ended', () => {
        try {
          this.apiService.interactionEvent(
            campaignUuid,
            userId,
            currentMedia.uuid || null
          );
        } catch (e) {
          console.log('Erro ao reportar o evento INTERACTION');
        }
        this.sendEvent('interaction');
      });
    } else {
      $(this.content).empty().append(`
        <div class="content-step-1">
          <div class="content-image">
            <img id="image_step_1" src="${
              currentMedia.content || currentMedia.url
            }" />
            <button class="btn-avancar background-primary color-secondary" id="avancar_btn_step_1">
              AVANÇAR
            </button>
          </div>
        </div>
      `);

      $(`img#image_step_1`)
        .one('load', () => {
          try {
            this.apiService.interactionEvent(
              campaignUuid,
              userId,
              currentMedia.uuid || null
            );
          } catch (e) {
            console.log('Erro ao reportar o evento INTERACTION');
          }
          this.sendEvent('interaction');
        })
        .each(function () {
          if (this.complete) {
            $(this).trigger('load');
          }
        });

      $('#avancar_btn_step_1').click(() => {
        this.sendEventComplete();
        this.nextRenderCurrentMedia();
      });
    }
  };

  sendEventComplete = () => {
    const {
      context: { userId },
      campaign: { campaignUuid },
      currentMedia,
    } = this;

    try {
      this.apiService.completeEvent(
        campaignUuid,
        userId,
        currentMedia.uuid || null
      );
      this.sendEvent('complete');
    } catch (e) {
      console.log('Erro ao reportar o evento COMPLETE');
      this.apiService.errorEvent(
        campaignUuid,
        userId,
        'error-send-event-complete',
        e.message || e
      );
      this.sendEvent('complete-error');
    }
  };

  renderConfirmationTerm = (funcNextAccept) => {
    const {
      context: { userId },
      campaign: { campaignUuid },
      currentMedia: {
        content: { confirmationTerm },
      },
    } = this;

    $(this.content).empty().append(`
      <div id="content-step-confirmation-term" class="content-step-confirmation-term">
        <h2>Termo de confirmação</h2>
        <div id="content-data-confirmation-term"></div>
        <div class="base-buttons-confirmation-term">
          <button id="btn-accept-confirmation-term" class="background-primary color-secondary">ACEITAR</button>
        </div>
      </div>
    `);
    const contentConfirmationTerm = $('#content-data-confirmation-term');
    contentConfirmationTerm.append(confirmationTerm);

    $('#btn-accept-confirmation-term').click((e) => {
      e.preventDefault();
      this.confirmationTermAccept = true;
      this.apiService.acceptConfirmationTermEvent(campaignUuid, userId);
      this.sendEvent('accept-confirmation-term');
      funcNextAccept();
    });
  };

  renderForm = () => {
    const {
      context: { userId },
      campaign: { campaignUuid },
      currentMedia: { uuid, content },
    } = this;

    this.apiService.interactionEvent(campaignUuid, userId, uuid || null);

    if (!content || content.questions.length === 0) {
      if (content.termPosition === 'after' && !this.confirmationTermAccept) {
        return this.renderConfirmationTerm(this.giveBebefit);
      }
    }

    if (content.termPosition === 'before' && !this.confirmationTermAccept) {
      return this.renderConfirmationTerm(this.renderForm);
    }

    this.clearAnswers();
    this.currentQuestionIndex = 0;
    this.currentQuestion = content.questions[this.currentQuestionIndex];

    $(this.content)
      .empty()
      .append('<div id="content-step-2" class="content-step-2-new"></div>');
    const contentStep2 = $('#content-step-2');

    contentStep2.append('<div id="step2_question_steps"></div>');
    const contentQuestionSteps = $('#step2_question_steps');
    content.questions.forEach((q, index) => {
      contentQuestionSteps.append(`
        <div id="step-question-dot-${index}" class="step-question-dot" />
      `);
    });

    contentStep2.append('<div id="step2_question_content"></div>');
    contentStep2.append(`
      <div id="step2_question_content_errors">
        <p id="question_message_error"></p>
      </div>
    `);

    contentStep2.append(`
      <div class="step2_question_buttons">
        <a id="step2_question_previous" class="color-primary border-primary" href="#">
         ANTERIOR
        </a>
        <a id="step2_question_next" class="background-primary color-secondary" href="#">
          PRÓXIMO
        </a>
      </div>
    `);
    $('#step2_question_previous').click((e) => {
      e.preventDefault();
      if (this.currentQuestionIndex > 0) {
        this.previousQuestion();
      }
    });
    $('#step2_question_next').click((e) => {
      e.preventDefault();
      if (!this.isValidAnswer()) {
        return;
      }
      this.nextQuestion();
    });
    this.loadCurrentQuestion();
  };

  setMessageErrorQuestion = (message) => {
    $('#question_message_error').text(message);
  };

  updateStatusSteps = () => {
    // const { mainData: { form } } = this;
    let stepIndex = 0;
    $('.step-question-dot').removeClass('active');
    while (stepIndex <= this.currentQuestionIndex) {
      $(`#step-question-dot-${stepIndex}`).addClass('active');
      stepIndex++;
    }

    // form.questions.forEach((q,index) => {
    //   contentQuestionSteps.append(`
    //     <div id="step-question-dot-${index}" class="step-question-dot" />
    //   `);
    // });
  };

  clearAnswers = () => {
    const {
      currentMedia: { content },
    } = this;

    if (content.questions && content.questions.length > 0) {
      content.questions.forEach((question) => {
        if (question.type === 'check' || question.type === 'radio') {
          question.options.forEach((option) => {
            option.selected = false;
          });
        } else {
          question.value = '';
        }
      });
    }
  };

  validateInputText = (messageError) => {
    const {
      required,
      fieldType,
      validateMax,
      max,
      validateMin,
      min,
      value,
    } = this.currentQuestion;
    if (required && !value) {
      this.setMessageErrorQuestion('Resposta obrigatória');
      return false;
    }
    if (fieldType === 'text') {
      if (validateMax) {
        if (value.length > max) {
          this.setMessageErrorQuestion(`Máximo de ${max} caracteres`);
          return false;
        }
      }
      if (validateMin) {
        if (value.length < min) {
          this.setMessageErrorQuestion(`Mínimo de ${min} caracteres`);
          return false;
        }
      }
    } else if (fieldType === 'number') {
      if (validateMax) {
        if (value.length > max) {
          this.setMessageErrorQuestion(`Máximo de ${max} caracteres`);
          return false;
        }
      }
      if (validateMin) {
        if (value.length < min) {
          this.setMessageErrorQuestion(`Mínimo de ${min} caracteres`);
          return false;
        }
      }
    } else if (fieldType === 'cpf') {
      if (value) {
        if (!/[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}/.test(value)) {
          this.setMessageErrorQuestion('CPF inválido');
          return false;
        }
        if (!Util.validCpf(value.replace(/\D/g, ''))) {
          this.setMessageErrorQuestion('CPF inválido');
          return false;
        }
      }
    } else if (fieldType === 'phone') {
      if (value) {
        if (!/\(\d{2,}\) \d{4,5}\-\d{4,4}/.test(value)) {
          this.setMessageErrorQuestion('Número inválido');
          return false;
        }
      }
    } else if (fieldType === 'cep') {
      if (value) {
        if (!/\d{5}\-\d{3}/.test(value)) {
          this.setMessageErrorQuestion('CEP inválido');
          return false;
        }
      }
    }
    return true;
  };

  validateInputDate = () => {
    const {
      required,
      value,
      dateMax,
      dateMaxType,
      dateMin,
      dateMinType,
    } = this.currentQuestion;
    if (required && !value) {
      this.setMessageErrorQuestion('Resposta obrigatória');
      return false;
    }
    if (value) {
      let dateValue = parse(value, 'dd/MM/yyyy', new Date());
      if (!isValid(dateValue)) {
        this.setMessageErrorQuestion('Data inválida');
        return false;
      }

      dateValue = setHours(dateValue, 0);
      dateValue = setMinutes(dateValue, 0);
      dateValue = setSeconds(dateValue, 0);
      dateValue = setMilliseconds(dateValue, 0);

      if (dateMaxType && dateMaxType !== VALIDATE_DATE.no_limit) {
        let dateMaxValidate = new Date();
        if (dateMaxType === VALIDATE_DATE.now) {
          //nada a ser feito
        } else if (dateMaxType === VALIDATE_DATE.yesterday) {
          dateMaxValidate = subDays(dateMaxValidate, 1);
        } else if (dateMaxType === VALIDATE_DATE.tomorrow) {
          dateMaxValidate = addDays(dateMaxValidate, 1);
        } else if (dateMaxType === VALIDATE_DATE.fixed) {
          dateMaxValidate = parse(dateMax, 'dd/MM/yyyy', new Date());
        }

        dateMaxValidate = setHours(dateMaxValidate, 0);
        dateMaxValidate = setMinutes(dateMaxValidate, 0);
        dateMaxValidate = setSeconds(dateMaxValidate, 0);
        dateMaxValidate = setMilliseconds(dateMaxValidate, 0);
        if (
          !isEqual(dateValue, dateMaxValidate) &&
          !isBefore(dateValue, dateMaxValidate)
        ) {
          this.setMessageErrorQuestion(
            `A data máxima é ${format(dateMaxValidate, 'dd/MM/yyyy')}`
          );
          return false;
        }
      }

      if (dateMinType && dateMinType !== VALIDATE_DATE.no_limit) {
        let dateMinValidate = new Date();
        if (dateMinType === VALIDATE_DATE.now) {
          //nada a ser feito
        } else if (dateMinType === VALIDATE_DATE.yesterday) {
          dateMinValidate = subDays(dateMinValidate, 1);
        } else if (dateMinType === VALIDATE_DATE.tomorrow) {
          dateMinValidate = addDays(dateMinValidate, 1);
        } else if (dateMinType === VALIDATE_DATE.fixed) {
          dateMinValidate = parse(dateMin, 'dd/MM/yyyy', new Date());
        }

        dateMinValidate = setHours(dateMinValidate, 0);
        dateMinValidate = setMinutes(dateMinValidate, 0);
        dateMinValidate = setSeconds(dateMinValidate, 0);
        dateMinValidate = setMilliseconds(dateMinValidate, 0);
        if (
          !isEqual(dateValue, dateMinValidate) &&
          !isAfter(dateValue, dateMinValidate)
        ) {
          this.setMessageErrorQuestion(
            `A data mínima é ${format(dateMinValidate, 'dd/MM/yyyy')}`
          );
          return false;
        }
      }
    }

    return true;
  };

  isValidAnswer = () => {
    if (this.mainData && this.currentQuestion) {
      let result = false;
      const { type } = this.currentQuestion;
      this.setMessageErrorQuestion('');

      if (type === 'check' || type === 'radio') {
        const { rightAnswerRequired, required, options } = this.currentQuestion;
        if (rightAnswerRequired || required) {
          for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
              result = true;
              break;
            }
          }
          if (!result) {
            this.setMessageErrorQuestion('Resposta obrigatória');
          }
        } else {
          result = true;
        }
      } else if (type === 'text' || type === 'input') {
        result = this.validateInputText();
      } else if (type === 'date') {
        result = this.validateInputDate();
      }

      if (result) {
        $('#step2_question_next').removeClass('disabled');
      } else {
        $('#step2_question_next').addClass('disabled');
      }

      return result;
    } else {
      return true;
    }
  };

  jumpQuestion = () => {
    this.giveBebefit();
  };

  previousQuestion = () => {
    this.isNextQuestion = false;
    const {
      currentMedia: { content },
    } = this;
    if (this.currentQuestionIndex > 0) {
      this.currentQuestionIndex--;
      this.currentQuestion = content.questions[this.currentQuestionIndex];
      this.loadCurrentQuestion();
    }
  };

  trackQuiz = () => {
    const {
      context: {
        userId,
        zone: { uuid: zoneUuid },
      },
      campaign: { campaignUuid },
      currentMedia: { uuid: mediaUuid, content },
    } = this;

    if (content.questions && content.questions.length > 0) {
      const arrayQuiz = [];
      const question = content.questions[this.currentQuestionIndex];
      if (question.type === 'radio' || question.type === 'check') {
        question.options.forEach((option) => {
          arrayQuiz.push({
            campaignUuid,
            userId,
            mediaUuid,
            zoneUuid,
            // requestId: this.requestId,
            questionUuid: question.uuid || question.questionUuid,
            questionName: question.title,
            answer: '',
            questionType: question.type,
            questionFieldType: null,
            questionOptionSelected: option.selected || false, //check | radio
            questionOptionUuid: option.uuid || option.optionUuid,
            questionOptionName: option.description,
            questionOptionsIsAnswer: option.isAnswer,
          });
        });
      } else {
        arrayQuiz.push({
          campaignUuid,
          userId,
          mediaUuid,
          zoneUuid,
          // requestId: this.requestId,
          questionUuid: question.uuid,
          questionName: question.title,
          answer: Util.clearFormat(question.value, question.fieldType),
          questionType: question.type,
          questionFieldType:
            question.type === 'text' ? question.fieldType : null,
          questionOptionSelected: false, //check | radio
          questionOptionUuid: null,
          questionOptionName: null,
          questionOptionsIsAnswer: false,
        });
      }
      if (arrayQuiz && arrayQuiz.length > 0) {
        this.apiService.trackerQuiz(arrayQuiz, campaignUuid, userId, mediaUuid);
      }
    }
  };

  nextQuestion = () => {
    this.trackQuiz();

    if (this.isNextQuestion) {
      const {
        currentMedia: { content },
      } = this;
      const lastQuestionIndex = content.questions.length - 1;
      if (this.currentQuestionIndex < lastQuestionIndex) {
        this.currentQuestionIndex++;
        this.currentQuestion = content.questions[this.currentQuestionIndex];
        this.loadCurrentQuestion();
      } else {
        this.isNextQuestion = false;
        this.finalizarQuestion();
      }
    }
  };

  isAnswerOk = async () => {
    const {
      currentMedia: { content },
    } = this;

    if (content.questions && content.questions.length > 0) {
      let answerOk = true;
      content.questions.forEach((question) => {
        if (answerOk) {
          if (question.type === 'check' || question.type === 'radio') {
            if (question.rightAnswerRequired) {
              const isOptionInvalid = question.options.find(
                (option) =>
                  (option.isAnswer && !option.selected) ||
                  (!option.isAnswer && option.selected)
              );
              if (isOptionInvalid) {
                answerOk = false;
              }
            }
          }
        }
      });
      return answerOk;
    }

    return true;
  };

  renderFormAgain = () => {
    const {
      mainData: { media },
    } = this;

    $(this.content)
      .empty()
      .append('<div id="content-step-4" class="content-step-4"></div>');
    const contentStep4 = $('#content-step-4');

    const labelButton =
      media && Util.isVideo(media) ? 'ASSISTIR NOVAMENTE' : 'TENTAR NOVAMENTE';
    const message =
      media && Util.isVideo(media)
        ? 'Mas não desista. Assista novamente a publicidade e, após acertar as questões, você ganhará o benefício :)'
        : 'Mas não desista. Tente novamente e, após acertar as questões, você ganhará o benefício :)';

    contentStep4.append(`
      <div class="step4_title">
        <span>Foi por pouco!</span>
      </div>
      <div class="step4_subtitle">
        ${message}
      </div>
      <div>
        <button class="step4_button_next background-primary color-secondary" id="step4_button_back">
          ${labelButton}
        </button>
      </div>
    `);

    $('#step4_button_back').click((e) => {
      e.preventDefault();
      this.initRender();
    });
  };

  loadTemplateWrongAnswer = () => {
    const {
      currentMedia: { content },
    } = this;

    content.questions.forEach((question) => {
      if (question.type === 'check' || question.type === 'radio') {
        question.options.forEach((answer) => {
          answer.selected = false;
        });
      } else {
        question.value = null;
      }
    });
    this.renderFormAgain();
  };

  loadFinalizarAnimation = () => {
    $('#step2_question_next').text('Carregando...');
    $('#step2_question_next').addClass('btn-finalizar');
  };

  finalizarQuestion = async () => {
    const {
      currentMedia: { content },
    } = this;

    try {
      this.loadFinalizarAnimation();
      const isOk = await this.isAnswerOk();
      if (isOk) {
        if (content.termPosition === 'after' && !this.confirmationTermAccept) {
          return this.renderConfirmationTerm(() => {
            this.sendEventComplete();
            this.nextRenderCurrentMedia();
          });
        }
        this.sendEventComplete();
        this.nextRenderCurrentMedia();
      } else {
        this.loadTemplateWrongAnswer();
      }
    } catch (e) {
      console.error(e);
      this.renderError();
    }
  };

  renderInputRating = (content) => {
    const ratingInit = this.currentQuestion.value;
    content.append(`
      <div class="star-list-artemis">
        <div class="star-rating-artemis question">
          <span 
            id="item-fa-star-1" 
            class="fa ${
              ratingInit && ratingInit >= 1
                ? 'rating-fa-star'
                : 'rating-fa-star-o'
            }">
            <svg aria-hidden="true" focusable="false" data-rating="1" data-prefix="fas" data-icon="star" class="item-rating svg-inline--fa fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
          </span>
          <span 
            id="item-fa-star-2" 
            class="fa ${
              ratingInit && ratingInit >= 2
                ? 'rating-fa-star'
                : 'rating-fa-star-o'
            }">
            <svg aria-hidden="true" focusable="false" data-rating="2" data-prefix="fas" data-icon="star" class="item-rating svg-inline--fa fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
          </span>
          <span 
            id="item-fa-star-3" 
            class="fa ${
              ratingInit && ratingInit >= 3
                ? 'rating-fa-star'
                : 'rating-fa-star-o'
            }">
            <svg aria-hidden="true" focusable="false" data-rating="3" data-prefix="fas" data-icon="star" class="item-rating svg-inline--fa fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
          </span>
          <span 
            id="item-fa-star-4" 
            class="fa ${
              ratingInit && ratingInit >= 4
                ? 'rating-fa-star'
                : 'rating-fa-star-o'
            }">
            <svg aria-hidden="true" focusable="false" data-rating="4" data-prefix="fas" data-icon="star" class="item-rating svg-inline--fa fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
          </span>
          <span 
            id="item-fa-star-5"
            class="fa ${
              ratingInit && ratingInit >= 5
                ? 'rating-fa-star'
                : 'rating-fa-star-o'
            }">
            <svg aria-hidden="true" focusable="false" data-rating="5" data-prefix="fas" data-icon="star" class="item-rating svg-inline--fa fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
          </span>
        </div>
      </div>
    `);
    $(`.item-rating`).click((e) => {
      let rating = $(e.currentTarget).data('rating');
      if (this.currentQuestion.value !== rating) {
        this.currentQuestion.value = rating;
      } else {
        this.currentQuestion.value = null;
        rating = -1;
      }
      let i = 0;
      while (i < 5) {
        if (i < rating) {
          $(`#item-fa-star-${i + 1}`)
            .removeClass('rating-fa-star-o')
            .addClass('rating-fa-star');
        } else {
          $(`#item-fa-star-${i + 1}`)
            .removeClass('rating-fa-star')
            .addClass('rating-fa-star-o');
        }

        i++;
      }
    });
  };

  renderInputDate = (content) => {
    const {
      uuid,
      value,
      acceptHour,
      dateFormat,
      dateMax,
      dateMaxType,
      dateMin,
      dateMinType,
    } = this.currentQuestion;
    content.append(`
      <input id="${uuid}" class="step2_answer_input date" type="text" pattern="[0-9]*" inputmode="numeric" value="${value}" />
    `);

    let options = {};
    if (dateMaxType && dateMaxType !== VALIDATE_DATE.no_limit) {
      let date = new Date();
      if (dateMaxType === VALIDATE_DATE.now) {
        //nada a ser feito
      } else if (dateMaxType === VALIDATE_DATE.yesterday) {
        date = subDays(date, 1);
      } else if (dateMaxType === VALIDATE_DATE.tomorrow) {
        date = addDays(date, 1);
      } else if (dateMaxType === VALIDATE_DATE.fixed) {
        date = parse(dateMax, 'dd/MM/yyyy', new Date());
      }
      options.maxDate = date;
    }

    if (dateMinType && dateMinType !== VALIDATE_DATE.no_limit) {
      let date = new Date();
      if (dateMinType === VALIDATE_DATE.now) {
        //nada a ser feito
      } else if (dateMinType === VALIDATE_DATE.yesterday) {
        date = subDays(date, 1);
      } else if (dateMinType === VALIDATE_DATE.tomorrow) {
        date = addDays(date, 1);
      } else if (dateMinType === VALIDATE_DATE.fixed) {
        date = parse(dateMin, 'dd/MM/yyyy', new Date());
      }
      options.minDate = date;
    }

    $('.date')
      .mask('00/00/0000', { placeholder: '__/__/____' })
      .datepicker(options)
      .keyup((e) => {
        this.currentQuestion.value = e.target.value;
        this.isValidAnswer();
      })
      .change((e) => {
        this.currentQuestion.value = e.target.value;
        this.isValidAnswer();
      });
  };

  loadCurrentQuestion = () => {
    this.updateStatusSteps();

    const questionContent = $('#step2_question_content');
    questionContent.empty();
    questionContent.append(
      `<div>${this.currentQuestionIndex + 1} ${
        this.currentQuestion.title
      }</div>`
    );
    questionContent.append('<div id="step2_question_answers"></div>');
    const answersContent = $('#step2_question_answers');

    if (
      this.currentQuestion.type === 'check' ||
      this.currentQuestion.type === 'radio'
    ) {
      const type = this.currentQuestion.type === 'check' ? 'checkbox' : 'radio';
      for (const i in this.currentQuestion.options) {
        const id = `answer${i}`;
        const name =
          this.currentQuestion.type === 'check' ? `answer${i}` : 'answer';
        const answer = this.currentQuestion.options[i];
        const checked = answer.selected ? 'checked="checked"' : '';
        let currentAnswer = '';
        if (answer.selected) {
          if (answer.isAnswer) {
            currentAnswer = '<i class="fa fa-check"/>';
          } else if (answer.isAnswer !== undefined) {
            currentAnswer = '<i class="fa fa-times"/>';
          }
        }
        answersContent.append(`
          <label>
            <input index="${i}" id="${id}" ${checked} class="step2_answer" type="${type}" name="${name}" value="${answer.optionUuid}"/>
            ${answer.description}${currentAnswer}
          </label>
        `);

        $(`#${id}`).click((e) => this.onAnswerClicked(e));
      }
    } else {
      if (
        this.currentQuestion.type === 'text' ||
        this.currentQuestion.type === 'input' ||
        this.currentQuestion.type === 'number'
      ) {
        if (
          this.currentQuestion.fieldType === 'text' ||
          !this.currentQuestion.fieldType
        ) {
          const { type } = this.currentQuestion;
          const typeInput = type === 'input' ? 'text' : type;
          answersContent.append(`
            <input id="${this.currentQuestion.uuid}" class="step2_answer_input" type="${typeInput}" value="${this.currentQuestion.value}" />
          `);
          $(`#${this.currentQuestion.uuid}`)
            .keyup((e) => {
              this.currentQuestion.value = e.target.value;
              this.isValidAnswer();
            })
            .change((e) => {
              this.currentQuestion.value = e.target.value;
              this.isValidAnswer();
            });
        } else if (this.currentQuestion.fieldType === 'number') {
          answersContent.append(`
            <input id="${this.currentQuestion.uuid}" class="step2_answer_input" type="tel" pattern="[0-9]*" inputmode="numeric" value="${this.currentQuestion.value}" />
          `);
          $(`#${this.currentQuestion.uuid}`)
            .keyup((e) => {
              this.currentQuestion.value = e.target.value;
              this.isValidAnswer();
            })
            .change((e) => {
              this.currentQuestion.value = e.target.value;
              this.isValidAnswer();
            });
        } else if (this.currentQuestion.fieldType === 'cpf') {
          //render input cpf
          answersContent.append(`
            <input id="${this.currentQuestion.uuid}" class="step2_answer_input cpf" type="text" pattern="[0-9]*" inputmode="numeric" value="${this.currentQuestion.value}" />
          `);
          $('.cpf')
            .mask('000.000.000-00', { placeholder: '___.___.___-__' })
            .keyup((e) => {
              this.currentQuestion.value = e.target.value;
              this.isValidAnswer();
            })
            .change((e) => {
              this.currentQuestion.value = e.target.value;
              this.isValidAnswer();
            });
        } else if (this.currentQuestion.fieldType === 'phone') {
          //render input phone
          answersContent.append(`
            <input id="${this.currentQuestion.uuid}" class="step2_answer_input phone" type="text" pattern="[0-9]*" inputmode="numeric" value="${this.currentQuestion.value}" />
          `);
          const maskBehavior = function (val) {
            return val.replace(/\D/g, '').length === 11
              ? '(00) 00000-0000'
              : '(00) 0000-00009';
          };
          const options = {
            onKeyPress: function (val, e, field, options) {
              field.mask(maskBehavior.apply({}, arguments), options);
            },
            placeholder: '(__) _____-____',
          };

          $('.phone')
            .mask(maskBehavior, options)
            .keyup((e) => {
              this.currentQuestion.value = e.target.value;
              this.isValidAnswer();
            })
            .change((e) => {
              this.currentQuestion.value = e.target.value;
              this.isValidAnswer();
            });
          } else if (this.currentQuestion.fieldType === 'cep') {
            //render input cep
            answersContent.append(`
              <input id="${this.currentQuestion.uuid}" class="step2_answer_input cep" type="text" pattern="[0-9]*" inputmode="numeric" value="${this.currentQuestion.value}" />
            `);
            $('.cep')
              .mask('00000-000', { placeholder: '_____-___' })
              .keyup((e) => {
                this.currentQuestion.value = e.target.value;
                this.isValidAnswer();
              })
              .change((e) => {
                this.currentQuestion.value = e.target.value;
                this.isValidAnswer();
              });
          }
      } else if (this.currentQuestion.type === 'date') {
        //render input date
        this.renderInputDate(answersContent);
      } else if (this.currentQuestion.type === 'rating') {
        this.renderInputRating(answersContent);
      }
    }

    if (this.currentQuestionIndex === 0) {
      // $('#step2_question_previous').text('');
      $('#step2_question_previous').addClass('disabled');
    } else {
      // $('#step2_question_previous').text('ANTERIOR');
      $('#step2_question_previous').removeClass('disabled');
    }

    const {
      currentMedia: { content },
    } = this;

    if (this.currentQuestionIndex === content.questions.length - 1) {
      $('#step2_question_next').text('FINALIZAR');
    } else {
      $('#step2_question_next').text('PRÓXIMO');
    }

    this.isValidAnswer();

    this.isNextQuestion = true;
  };

  onAnswerClicked = (e) => {
    const { currentTarget: answer } = e;
    const { type, options } = this.currentQuestion;
    if (type === 'radio') {
      options.forEach((a) => (a.selected = false));
    }
    const i = Number.parseInt(answer.id.replace('answer', ''));
    options[i].selected = answer.checked;
    this.isValidAnswer();
  };

  renderError = () => {
    $(this.content)
      .empty()
      .append('<div id="content-step-4" class="content-step-4"></div>');
    const contentStep4 = $('#content-step-4');

    contentStep4.append(`
      <div class="step4_title">
        <span>Atenção!</span>
      </div>
      <div class="step4_subtitle">
        Houve um problema no processamento. Tente novamente mais tarde!
      </div>
      <div>
        <button class="step4_button_next" id="step4_button_back">
          VOLTAR PARA O INÍCIO
        </button>
      </div>
    `);

    $('#step4_button_back').click((e) => {
      e.preventDefault();
      this.initRender();
    });
  };

  renderSuccess = () => {
    if (
      this.type === CAMPAIGN_TYPE_CODE ||
      (this.type === CAMPAIGN_TYPE_PROVIDER &&
        (this.mainData.type === 'interno' || this.mainData.type === 'internal'))
    ) {
      const {
        mainData: { success },
      } = this;

      $(this.content).empty();

      if (success.type === 'external') {
        let urlRedirect = success.url;
        if (urlRedirect.indexOf('http') !== 0) {
          urlRedirect = `http://${urlRedirect}`;
        }
        window.location.replace(urlRedirect);
      } else if (success.type === 'internal') {
        $(this.content)
          .empty()
          .append('<div id="content-step-4" class="content-step-4"></div>');
        const contentStep4 = $('#content-step-4');

        const { enabled, label, campaignIndex } = this.nextCampaign;
        if (enabled) {
          const { campaigns } = this.context;
          if (campaigns.length - 1 > campaignIndex) {
            contentStep4.append(`
              <div class="step4_next_campaign">
                <button class="btn-avancar background-primary color-secondary" id="avancar_proxima_campanha">
                  ${label || 'Mais internet'}
                </button>
              </div>
            `);
            $('#avancar_proxima_campanha').click(() => {
              this.nextRenderCampaign();
            });
          }
        }

        const logo = success.icon ? `<img src="${success.icon}">` : '';
        contentStep4.append(`
          <div class="step4_title">
            ${logo}
            <span>${success.title || ''}</span>
          </div>
          <div class="step4_subtitle">
            ${success.description || ''}
          </div>
        `);
        if (success.image) {
          contentStep4.append(`
            <div class="step4_center">
              <img class="banner" src="${success.image}">
            </div>
          `);
        }
      }
    } else {
      $(this.content).empty();
    }

    if (this.cbGiveBenefit) {
      this.cbGiveBenefit();
    }
  };

  giveBebefit = async () => {
    $(this.content)
      .empty()
      .append('<div id="content-step-3" class="content-step-3"></div>');
    const contentStep = $('#content-step-3');

    // <img src="https://channel.mobicare.com.br/libs/img/loading.gif" style="width: 4em;padding: 15px;"><br>
    contentStep.append(`
      <div id="loading" class="step3_success_subtitle">
        <span>Por favor aguarde...</span>
      </div>
    `);

    // const {
    //   context: { userId },
    //   campaign: { campaignUuid },
    // } = this;

    this.renderSuccess();

    // try {
    //   await this.apiService.conversion(campaignUuid, userId);
    //   this.sendEvent('conversion');
    //   this.renderSuccess();
    // } catch (e) {
    //   console.error(e);
    //   this.renderError();
    // }
  };
}

export default CampaignController;
